import { deviceIdsApiEndpoints } from '@/api/endpoints';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useDeviceIds() {
  return useQuery({
    queryKey: ['device-ids'],
    queryFn: async () => {
      const { data } = await deviceIdsApiEndpoints.retrieveList();
      return data;
    },
  });
}

export function useDeleteDeviceId() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      await deviceIdsApiEndpoints.delete(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['device-ids'] });
    },
  });
}
